<template>
    <div class="
        {w:full;accent-color:primary;h:4;r:2;border:0;background:gray05;appearance:none;background-image:linear-gradient(primary,primary);background-repeat:no-repeat;background-size:66.6666%|100%}_input[type=range]
        {w:14;h:14;r:100%;bg:#fff;appearance:none;border:2|solid|primary}_input[type=range]::-webkit-slider-thumb
    ">
        <div class="h:54 flex gap:16 ai:center">
            <div>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3278_74797)">
                        <path d="M16.3125 9C16.3125 7.0606 15.5421 5.20064 14.1707 3.82928C12.7994 2.45792 10.9394 1.6875 9 1.6875C7.0606 1.6875 5.20064 2.45792 3.82928 3.82928C2.45792 5.20064 1.6875 7.0606 1.6875 9C1.6875 10.9394 2.45792 12.7994 3.82928 14.1707C5.20064 15.5421 7.0606 16.3125 9 16.3125C10.9394 16.3125 12.7994 15.5421 14.1707 14.1707C15.5421 12.7994 16.3125 10.9394 16.3125 9ZM0 9C0 6.61305 0.948212 4.32387 2.63604 2.63604C4.32387 0.948212 6.61305 0 9 0C11.3869 0 13.6761 0.948212 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C6.61305 18 4.32387 17.0518 2.63604 15.364C0.948212 13.6761 0 11.3869 0 9ZM6.24375 11.1832C6.77813 11.7598 7.69219 12.375 9 12.375C10.3078 12.375 11.2219 11.7598 11.7562 11.1832C12.0727 10.8422 12.607 10.8176 12.948 11.134C13.2891 11.4504 13.3137 11.9848 12.9973 12.3258C12.2238 13.1625 10.8879 14.0625 9.00352 14.0625C7.11914 14.0625 5.77969 13.166 5.00977 12.3258C4.69336 11.9848 4.71445 11.4504 5.05898 11.134C5.40352 10.8176 5.93438 10.8387 6.25078 11.1832H6.24375ZM5.07656 7.3125C5.07656 7.01413 5.19509 6.72798 5.40607 6.517C5.61705 6.30603 5.90319 6.1875 6.20156 6.1875C6.49993 6.1875 6.78608 6.30603 6.99706 6.517C7.20804 6.72798 7.32656 7.01413 7.32656 7.3125C7.32656 7.61087 7.20804 7.89702 6.99706 8.108C6.78608 8.31897 6.49993 8.4375 6.20156 8.4375C5.90319 8.4375 5.61705 8.31897 5.40607 8.108C5.19509 7.89702 5.07656 7.61087 5.07656 7.3125ZM11.8266 6.1875C12.1249 6.1875 12.4111 6.30603 12.6221 6.517C12.833 6.72798 12.9516 7.01413 12.9516 7.3125C12.9516 7.61087 12.833 7.89702 12.6221 8.108C12.4111 8.31897 12.1249 8.4375 11.8266 8.4375C11.5282 8.4375 11.242 8.31897 11.0311 8.108C10.8201 7.89702 10.7016 7.61087 10.7016 7.3125C10.7016 7.01413 10.8201 6.72798 11.0311 6.517C11.242 6.30603 11.5282 6.1875 11.8266 6.1875Z" fill="#6F737D" />
                    </g>
                    <defs>
                        <clipPath id="clip0_3278_74797">
                            <rect width="18" height="18" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="flex:1 mt:-10">
                <div class="rel pointer-event:none ml:7 w:100%">
                    <div class="abs t:center mt:35 top:50% translate(-50%,-50%)" :class="item.classes" :key="index" v-for="(item, index) in steps">{{ item.label }}</div>
                </div>
                <input :class="sliderTrackStyle()" :disabled="disabled" @input="update" :max="max" :min="min" step="1" type="range" :value="modelValue" />
            </div>
            <div>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.3125 9C16.3125 7.0606 15.5421 5.20064 14.1707 3.82928C12.7994 2.45792 10.9394 1.6875 9 1.6875C7.0606 1.6875 5.20064 2.45792 3.82928 3.82928C2.45792 5.20064 1.6875 7.0606 1.6875 9C1.6875 10.9394 2.45792 12.7994 3.82928 14.1707C5.20064 15.5421 7.0606 16.3125 9 16.3125C10.9394 16.3125 12.7994 15.5421 14.1707 14.1707C15.5421 12.7994 16.3125 10.9394 16.3125 9ZM0 9C0 6.61305 0.948212 4.32387 2.63604 2.63604C4.32387 0.948212 6.61305 0 9 0C11.3869 0 13.6761 0.948212 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C6.61305 18 4.32387 17.0518 2.63604 15.364C0.948212 13.6761 0 11.3869 0 9ZM6.20156 6.1875C6.49993 6.1875 6.78608 6.30603 6.99706 6.517C7.20804 6.72798 7.32656 7.01413 7.32656 7.3125C7.32656 7.61087 7.20804 7.89702 6.99706 8.108C6.78608 8.31897 6.49993 8.4375 6.20156 8.4375C5.90319 8.4375 5.61705 8.31897 5.40607 8.108C5.19509 7.89702 5.07656 7.61087 5.07656 7.3125C5.07656 7.01413 5.19509 6.72798 5.40607 6.517C5.61705 6.30603 5.90319 6.1875 6.20156 6.1875ZM10.7016 7.3125C10.7016 7.01413 10.8201 6.72798 11.0311 6.517C11.242 6.30603 11.5282 6.1875 11.8266 6.1875C12.1249 6.1875 12.4111 6.30603 12.6221 6.517C12.833 6.72798 12.9516 7.01413 12.9516 7.3125C12.9516 7.61087 12.833 7.89702 12.6221 8.108C12.4111 8.31897 12.1249 8.4375 11.8266 8.4375C11.5282 8.4375 11.242 8.31897 11.0311 8.108C10.8201 7.89702 10.7016 7.61087 10.7016 7.3125ZM9 10.125C9.59674 10.125 10.169 10.3621 10.591 10.784C11.0129 11.206 11.25 11.7783 11.25 12.375C11.25 12.9717 11.0129 13.544 10.591 13.966C10.169 14.3879 9.59674 14.625 9 14.625C8.40326 14.625 7.83097 14.3879 7.40901 13.966C6.98705 13.544 6.75 12.9717 6.75 12.375C6.75 11.7783 6.98705 11.206 7.40901 10.784C7.83097 10.3621 8.40326 10.125 9 10.125Z" fill="#6F737D" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        disabled: { default: false, type: Boolean },
        max: { default: 10, type: Number },
        min: { default: 0, type: Number },
        modelValue: { default: 0, type: Number },
        step: { default: 1, type: Number }
    });

    const steps = computed(() => {
        const steps = [];
        const len = Math.ceil((props.max - props.min) / props.step) + 1;
        const stepPercent = 1 / (len - 1);

        while (steps.length < len) {
            const index = steps.length;

            steps.push({
                label: props.min + (props.step * index),
                classes: [`left:${100 * Math.min(1, stepPercent * index)}%`, `ml:${-14 * Math.min(1, stepPercent * index)}`]
            });
        }

        return steps;
    });

    const emit = defineEmits(["update:modelValue"]);

    const sliderTrackStyle = () => {
        const ratio = Math.min(1, (props.modelValue - props.min) / (props.max - props.min));

        return [`background-size:${100 * ratio}%|100%!`];
    };

    const update = (event) => {
        emit("update:modelValue", event.target.value);
    };

    watch(() => props.modelValue, (current) => {
        let value = parseInt(current, 10) || 0;

        if (value > props.max) {
            value = props.max;
        } else if (value <= props.min) {
            value = props.min;
        }

        emit("update:modelValue", value);
    });
</script>
